import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PipesModule } from '../../pipes/pipes.module';
import { WidgetsComponent } from './widgets.component';
import { IbexIconModule } from '@ibexfusion/ibex-icon';
import { WeatherIconModule } from '@ibexfusion/weather-icon';
import { WidgetHeaderComponent } from './widget-header/widget-header.component';
import { IbexDatePipe } from '../../pipes/ibex-date/ibex-date.pipe';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { GlobalComponentsModule } from '../global-components.module';
import { CarouselModule } from '../carousel/carousel.module';
import { WeatherWidgetComponent } from './types/default/weather-widget/weather-widget.component';
import { InformationWidgetComponent } from './types/default/information-widget/information-widget.component';
import { TransportWidgetComponent } from './types/default/transport-widget/transport-widget.component';
import { RestaurantWidgetComponent } from './types/default/restaurant-widget/restaurant-widget.component';
import { NewsWidgetComponent } from './types/default/news-widget/news-widget.component';
import { GalleryWidgetComponent } from './types/default/gallery-widget/gallery-widget.component';
import { DefaultWidgetComponent } from './types/default/default-widget/default-widget.component';
import { EventWidgetComponent } from "./types/default/event-widget/event-widget.component";
import { GastronomyWidgetComponent } from "./types/default/gastronomy-widget/gastronomy-widget.component";
import { PersonWidgetComponent } from "./types/default/person-widget/person-widget.component";
import { ActivityWidgetComponent } from "./types/default/activity-widget/activity-widget.component";
import { WebcamWidgetComponent } from './types/default/webcam-widget/webcam-widget.component';
import { MemoryWidgetComponent } from './types/default/memory-widget/memory-widget.component';
import { AlphabetWidgetComponent } from './types/default/alphabet-widget/alphabet-widget.component';
import { MountainRailwayWidgetComponent } from "./types/default/mountain-railway-widget/mountain-railway-widget.component";
import { ShareWidgetComponent } from './types/default/share-widget/share-widget.component';
import { CinemaWidgetComponent } from './types/default/cinema-widget/cinema-widget.component';
import { OpeningHoursWidgetComponent } from './types/default/opening-hours-widget/opening-hours-widget.component';
import { ImportantNewsWidgetComponent } from './types/default/important-news-widget/important-news-widget.component';
import { AccommodationWidgetComponent } from './types/default/accommodation-widget/accommodation-widget.component';
import { OpeningStateWidgetComponent } from './types/default/opening-state-widget/opening-state-widget.component';
import { AirportWidgetComponent } from './types/default/airport-widget/airport-widget.component';
import { SocialMediaWidgetComponent } from './types/default/social-media-widget/social-media-widget.component';
import { SingleCarouselComponent } from '../single-carousel/single-carousel.component';
import { InformationWidgetInfoscreenComponent } from './types/infoscreen/information-widget/information-widget-infoscreen.component';
import { VideochatWidgetComponent } from './types/default/videochat-widget/videochat-widget.component';
import { MountainRailwayNewWidgetComponent } from './types/default/mountain-railway-widget-new/mountain-railway-new-widget.component';
import {
  SocialMediaFeedWidgetComponent
} from './types/default/social-media-feed-widget/social-media-feed-widget.component';
import {
  ManMadeWeatherWidgetComponent
} from './types/default/man-made-weather-widget/man-made-weather-widget.component';
import { NewsWidgetHybridComponent } from './types/hybrid/news-widget/news-widget-hybrid.component';
import { GalleryWidgetHybridComponent } from './types/hybrid/gallery-widget/gallery-widget-hybrid.component';
import { PersonWidgetHybridComponent } from './types/hybrid/person-widget/person-widget-hybrid.component';
import { EventWidgetHybridComponent } from './types/hybrid/events-widget/event-widget-hybrid.component';
import { ScreensaverWidgetHybridComponent } from './types/hybrid/screensaver-widget/screensaver-widget-hybrid.component';
import { PublicTransportWidgetComponent } from './types/default/public-transport-widget/public-transport-widget.component';
import { PinboardWidgetComponent } from './types/default/pinboard-widget/pinboard-widget.component'
import { NgxMasonryModule } from 'ngx-masonry'

@NgModule({
    imports: [CommonModule, FormsModule, IbexIconModule, PipesModule, WeatherIconModule, GlobalComponentsModule, CarouselModule, PinchZoomModule, NgxMasonryModule],
  declarations: [
    WidgetsComponent,
    WidgetHeaderComponent,
    WeatherWidgetComponent,
    InformationWidgetComponent,
    TransportWidgetComponent,
    RestaurantWidgetComponent,
    NewsWidgetComponent,
    GalleryWidgetComponent,
    DefaultWidgetComponent,
    EventWidgetComponent,
    GastronomyWidgetComponent,
    PersonWidgetComponent,
    ActivityWidgetComponent,
    SingleCarouselComponent,
    WebcamWidgetComponent,
    MemoryWidgetComponent,
    AlphabetWidgetComponent,
    MountainRailwayWidgetComponent,
    MountainRailwayNewWidgetComponent,
    ShareWidgetComponent,
    CinemaWidgetComponent,
    OpeningHoursWidgetComponent,
    ImportantNewsWidgetComponent,
    AccommodationWidgetComponent,
    OpeningStateWidgetComponent,
    AirportWidgetComponent,
    SocialMediaWidgetComponent,
    InformationWidgetInfoscreenComponent,
    NewsWidgetHybridComponent,
    GalleryWidgetHybridComponent,
    PersonWidgetHybridComponent,
    EventWidgetHybridComponent,
    ScreensaverWidgetHybridComponent,
    VideochatWidgetComponent,
    SocialMediaFeedWidgetComponent,
    ManMadeWeatherWidgetComponent,
    PublicTransportWidgetComponent,
    PinboardWidgetComponent
  ],
  exports: [
    WidgetsComponent
  ],
  providers: [
    IbexDatePipe
  ]
})
export class WidgetsComponentModule {}
